"use strict";

define('model/task',['./base', './person'], function (BaseModel, PersonModel) {
  var Task = BaseModel.extend({
    virtual: {
      'person.displayName': function personDisplayName() {
        var person = this.get('person');
        if (person) {
          return person.get('displayName');
        } else {
          return this.get('assignment');
        }
      }
    },
    initialize: function initialize() {
      BaseModel.prototype.initialize.apply(this, arguments);
      if (this.get('person')) {
        this.set('person', new PersonModel(this.get('person')));
      }
    },
    saveAnswer: function saveAnswer(value) {
      var url = '/rs/api/workflow/task/' + value;
      return BaseModel.prototype.sync.call(this, 'create', this, {
        url: url
      });
    },
    toJSON: function toJSON() {
      var attrs = _.clone(this.attributes);
      delete attrs.person;
      delete attrs.taskType;
      return attrs;
    }
  }, {
    all: function all() {
      return this.createCollection('/rs/api/workflow/task');
    },
    allBySubmissionId: function allBySubmissionId(id) {
      return this.createCollection('/rs/api/workflow/task/:documentId').params({
        documentId: id
      });
    },
    allHistoryByDocumentId: function allHistoryByDocumentId(id) {
      return this.createCollection('/rs/api/workflow/task/summary/:documentId').params({
        documentId: id
      });
    }
  });
  return Task;
});

